<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii"></a>
<p class="fmt"><span class="bold">By the same author</span></p>
<p class="fm">Non-fiction</p>
<p class="fm1">The Hundredth Year</p>
<p class="fm1">The Audit Report</p>
<p class="fm1">The Landlord’s Handbook</p>
<p class="fm">Fiction</p>
<p class="fm1">There’s only one Henry Green</p>
<p class="fm">As translator</p>
<p class="fm1">An Armenian Family Torn Apart</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Author.vue?d1f8d5ba